angular.module("searchPf.components", [])
  .component("searchPf", {
    templateUrl: "ng/components/searchPf/searchPf.view.html",
    bindings: {
      enableDisabledButton: '&',
      exportValue: '&',
      searchOnlyPf: '<',
      changeLabelActive: '<',
      hideRagsoc: '<',
      hideNdg: '<'
    },
    controller: SearchPf,
    controllerAs: "searchPfCtrl"
  })

function SearchPf(
  FinancialCustomer,
  $financialApiService,
  $rootScope,
  validationService
) {
  var self = this;

  self.$onInit = function () {
    self.$rootScope = $rootScope;
    self.enableErrorCF = true;
    self.supportModel = {
      customer: {
        piva: null,
        ragSoc: null,
        cf: null,
        ndg: "",
        identifierType: null,
        identifier: "",
        customerList: [],
      }
    }

  }

  self.changeInputValue = function (property, value) {
    if (property) {
      if (property == 'cf' && value && value.length == 16 && isNaN(value)) {
        self.enableErrorCF = validationService.validateCf(value);
      } else {
        self.enableErrorCF = true;
      }
      self.supportModel.customer[property] = value;
      self.initialCfPiva = self.supportModel.customer.piva;
    }
  }

  self.oneSelected = function () {
    return (
      self.supportModel.customer.piva ||
      self.supportModel.customer.ragSoc ||
      self.supportModel.customer.cf ||
      self.supportModel.customer.ndg
    );
  };

  self.getCustomer = function () {

    var customer = FinancialCustomer.build({
      cf: self.supportModel.customer.cf,
      ragSoc: self.supportModel.customer.ragSoc,
      ndg: self.supportModel.customer.ndg,
      piva: self.supportModel.customer.piva
    });

    self.supportModel.loading = true;
    self.supportModel.showResultTable = false;
    customer.metadata = null;
    $financialApiService
      .getCustomerByFilter(customer, self.searchOnlyPf)
      .then(function (listAppCustomer) {
        self.supportModel.customer.customerList = listAppCustomer.listAppCustomer
        self.searchFinish = true;
      })
      .catch(function (error) {
        console.log(error);
        self.searchFinish = true;
      })
      .finally(function () {
        self.supportModel.loading = false;
      });
  };

  self.setCustomer = function (customer) {
    console.log(customer);
    self.customerSelected = customer;
    self.enableDisabledButton({ value: self.customerSelected })
  }

  self.callFunctionForNextStep = function () {
    self.exportValue({
      customerUpdate: self.customerSelected
    })
  }

}